class PageFaq extends HTMLElement {
    constructor() {
    super();
    this.init();
    }

    init() {

        this.pageTitle = this.querySelectorAll('.page__title');
        this.sectionTitle = this.querySelectorAll('.item-title-section');
        this.sectionQuestion = this.querySelectorAll('.item-question-section');
        this.itemsQ = this.querySelectorAll('.item-q');
        if(this.sectionTitle.length){
            this.sectionTitle.forEach((btn) => {
                btn.addEventListener('click', this.seTitleSection.bind(this));
            });
        }

        
        if(this.itemsQ.length){
            this.itemsQ.forEach((btn) => {
                btn.addEventListener('click', this.toogleQ.bind(this));
            });
        }
        this.mobileSelected = this.querySelector('.selected-section-title');
        if(this.mobileSelected){
            this.mobileSelected.addEventListener('click', this.toogleQ.bind(this));
        }
    }

    toogleQ(evt){
        var elem = evt.target;
        console.log(elem);
        elem.classList.toggle('open')
    }

    seTitleSection(evt) {
        this.mobileSelected.classList.remove('open');
        const self = this;
        var elem = evt.target;
        if(elem.classList.contains('open')){
            return;
        }
        this.mobileSelected.querySelector('span').textContent = evt.target.querySelector('span')?.textContent;
        if(elem.classList[1]){
            console.log(elem.classList[1]);
            self.toggleFaq(elem.classList[1]);
        }
    }


    toggleFaq(_class) {
        console.log('_class', _class);
        this.sectionTitle.forEach((elem) => {
            if(elem.classList.contains('open')){
                elem.classList.remove('open');
            }
            if(elem.classList.contains(_class)){
                elem.classList.add('open');
            }
        });
        this.sectionQuestion.forEach((elem) => {
            if(elem.classList.contains('open')){
                elem.classList.remove('open');
            }
            if(elem.classList.contains(_class)){
                elem.classList.add('open');
            }
        });
        this.pageTitle.forEach((elem) => {
            if(elem.classList.contains('open')){
                elem.classList.remove('open');
            }
            if(elem.classList.contains(_class)){
                elem.classList.add('open');
            }
        });
    }
}
  
customElements.define('page-faq', PageFaq);
